var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_910)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.14286V32.8571C9 34.5929 10.3851 36 12.0938 36H32.9062C34.6149 36 36 34.5929 36 32.8571V8.27017C36 7.43065 35.6694 6.62602 35.0818 6.03566L29.9788 0.90834C29.3996 0.326396 28.6179 0 27.8033 0H12.0938C10.3851 0 9 1.40711 9 3.14286ZM10.9688 32.8571V3.14286C10.9688 2.51167 11.4724 2 12.0938 2H27.4219V8.85714C27.4219 10.0406 28.3663 11 29.5312 11H34.0312V32.8571C34.0312 33.4883 33.5276 34 32.9062 34H12.0938C11.4724 34 10.9688 33.4883 10.9688 32.8571ZM34.0312 9V8.27017C34.0312 7.96489 33.911 7.6723 33.6974 7.45762L29.3906 3.13036V8.85714C29.3906 8.93604 29.4536 9 29.5312 9H34.0312Z",
    fill: "#9D9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0625 14.7656C23.0625 14.222 23.5032 13.7812 24.0469 13.7812H30.5156C31.0593 13.7812 31.5 14.222 31.5 14.7656C31.5 15.3093 31.0593 15.75 30.5156 15.75H24.0469C23.5032 15.75 23.0625 15.3093 23.0625 14.7656Z",
    fill: "#6BB3EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0625 19.2656C23.0625 18.722 23.5032 18.2812 24.0469 18.2812H30.5156C31.0593 18.2812 31.5 18.722 31.5 19.2656C31.5 19.8093 31.0593 20.25 30.5156 20.25H24.0469C23.5032 20.25 23.0625 19.8093 23.0625 19.2656Z",
    fill: "#508FD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0625 23.7656C23.0625 23.222 23.5032 22.7812 24.0469 22.7812H30.5156C31.0593 22.7812 31.5 23.222 31.5 23.7656C31.5 24.3093 31.0593 24.75 30.5156 24.75H24.0469C23.5032 24.75 23.0625 24.3093 23.0625 23.7656Z",
    fill: "#3770C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4062C0 9.47427 0.75552 8.71875 1.6875 8.71875H18.5625C19.4945 8.71875 20.25 9.47427 20.25 10.4062V27.2812C20.25 28.2132 19.4945 28.9688 18.5625 28.9688H1.6875C0.755519 28.9688 0 28.2132 0 27.2812V10.4062Z",
    fill: "#3770C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14465 24.2117L3.9375 12.9375H5.85242L7.23669 20.6818L8.92859 12.9375H11.1511L12.7738 20.8125L14.1965 12.9375H16.073L13.8274 24.2117H11.8433L9.99756 15.783L8.16724 24.2117H6.14465Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.2abf7b2b1ead420e49065bc0a9e2e266.svg";
export { ForwardRef as ReactComponent };